import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./TextLong.css";

export default function ScreenText({ currentSlide, isMobile }) {

    if (!currentSlide.fullScreenText) {
        return null;
    }

    const processParagraph = (paragraph) => {
        const splitForOpeningTag = paragraph.split("<");

        const processNoTag = (seg) => {
            const splitForClosingTag = seg.split(">");
            return splitForClosingTag.length > 1
                ? splitForClosingTag[1]
                : splitForClosingTag[0];
        };

        const tagToComponent = {
            h: "text-long-highlight",
            t: "text-title",
            q: "text-quote",
            s: "text-long-space",
            b: "text-long-bold",
            i: "text-long-italic",
            wh: "text-long-white",
            l: (content) => (
                <a
                    className="text-long-link"
                    rel="noreferrer"
                    href={content.split("(")[1].split(")")[0]}
                    target="_blank"
                >
                    {content.split("(")[0]}
                </a>
            ),
            image: (src) => (
                <LazyLoadImage
                    src={src}
                    loading="lazy"
                    style={{ width: '100%', height: 'auto' }} // You can modify this or add additional styles as needed
                />
            ),
        };

        const processTag = (seg) => {
            const [tag, content] = seg.split(">");
            if (tag in tagToComponent) {
                const TagComponent = tagToComponent[tag];
                if (typeof TagComponent === "function") {
                    return TagComponent(content);
                }
                return <span className={TagComponent}>{content}</span>;
            }
            return content;
        };

        return (
            <div>
                <p
                    style={{
                        color: "white",
                        fontSize: isMobile ? "5vw" : "18px",
                        textAlign: "left",
                        margin: "1vh 3vw",
                    }}
                >
                    {splitForOpeningTag.map((s, i) =>
                        i % 2 === 0 ? processNoTag(s) : processTag(s)
                    )}
                </p>
            </div>
        );
    };

    return (
        <div
            style={{
                position: "fixed",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "100",
                flexDirection: "column",
                opacity: currentSlide.fullScreenText ? "1" : "0.0",
                backgroundColor: "black",
                width: "30vw",
                height: "100vh",
                right: "0",
            }}
        >
            {currentSlide.fullScreenText.split("\r\n\r\n").map(processParagraph)}
        </div>
    );
}
